import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { DIR_LTR, DIR_RTL } from "constants/ThemeConstant";

/******************************************************************
 * ##: Render auth route layout shell
 * Render the shell used by /auth routes while Auth0 handles unauthenticated flow.
 * This layout avoids an early redirect to /dashboard that could conflict with RouteInterceptor before Auth0 completes.
 * @param {{ direction: string }} props - Layout props
 * @returns {JSX.Element} - Auth container or redirect for authenticated users
 * History:
 * 12-04-2026: Updated comment structure to SalesPark custom style
 ******************************************************************/
const AuthLayout = ({ direction }) => {
  const { isAuthenticated } = useAuth0();
  const dirAttr = direction === DIR_RTL ? "rtl" : DIR_LTR;

  if (isAuthenticated === true) {
    return <Redirect to="/dashboard" />;
  }

  return <div className="auth-container" dir={dirAttr} />;
};

export default AuthLayout;
